<template>
  <VWidget
    :title="$t('Order Summary')"
    class="mb-4"
  >
    <div slot="widget-content">
      <v-list
        two-line
        dense
      >
        <v-list-tile>
          <v-list-tile-content>
            <v-list-tile-title>
              {{ $t('Subtotal') }}
              <span v-if="order.discountIncluded() && order.summary.total_items_discount.amount > 0">
                ({{ $t('includes discounts') }})
              </span>
            </v-list-tile-title>
            <v-list-tile-sub-title>{{ $t('{0} items', [order.summary.total_items_count]) }}</v-list-tile-sub-title>
          </v-list-tile-content>

          <v-list-tile-action>
            <v-chip
              small
              color="grey darken-2"
              dark
            >
              {{ order.summary.total_items_amount | money }}
            </v-chip>
          </v-list-tile-action>
        </v-list-tile>

        <v-divider/>

        <v-list-tile v-if="order.shipping && order.shipping.method">
          <v-list-tile-content>
            <v-list-tile-title>
              {{ $t('Shipping and packaging') }}
              <span v-if="order.discountIncluded() && order.summary.total_shipping_discount.amount > 0">
                ({{ $t('includes discounts') }})
              </span>
            </v-list-tile-title>
            <v-list-tile-sub-title>{{ order.shipping.method }}</v-list-tile-sub-title>
          </v-list-tile-content>

          <v-list-tile-action>
            <v-chip
              small
              color="grey darken-2"
              dark
            >
              {{ order.summary.total_shipping | money }}
            </v-chip>
          </v-list-tile-action>
        </v-list-tile>

        <v-divider/>

        <v-list-group
          append-icon="">
          <v-list-tile slot="activator">
            <v-list-tile-content>
              <v-list-tile-title>{{ $t('Discounts') }}</v-list-tile-title>
            </v-list-tile-content>

            <v-icon v-if="order.summary.total_discount.amount > 0">keyboard_arrow_down</v-icon>

            <v-list-tile-action>
              <v-chip
                small
                color="grey darken-2"
                dark
              >
                - {{ order.summary.total_discount | money }}
              </v-chip>
            </v-list-tile-action>
          </v-list-tile>

          <template v-if="order.summary.total_discount.amount > 0">
            <v-list-tile>
              <v-list-tile-content>
                <v-list-tile-sub-title>
                  {{ $t('Items Discount') }}
                </v-list-tile-sub-title>
              </v-list-tile-content>

              <v-list-tile-action>
                <v-chip
                  small
                  color="transparent"
                >
                  {{ order.summary.total_items_discount | money }}
                </v-chip>
              </v-list-tile-action>
            </v-list-tile>

            <v-list-tile>
              <v-list-tile-content>
                <v-list-tile-sub-title>
                  {{ $t('Shipping Discount') }}
                </v-list-tile-sub-title>
              </v-list-tile-content>

              <v-list-tile-action>
                <v-chip
                  small
                  color="transparent"
                >
                  {{ order.summary.total_shipping_discount | money }}
                </v-chip>
              </v-list-tile-action>
            </v-list-tile>
          </template>
        </v-list-group>

        <v-divider/>

        <v-list-group append-icon="">
          <v-list-tile slot="activator">
            <v-list-tile-content>
              <v-list-tile-title>{{ $t('Taxes') }}</v-list-tile-title>
            </v-list-tile-content>

            <v-icon v-if="order.taxes && order.taxes.length > 0">keyboard_arrow_down</v-icon>

            <v-list-tile-action>
              <v-chip
                small
                color="primary"
                dark
              >
                {{ order.summary.total_taxes | money }}
              </v-chip>
            </v-list-tile-action>
          </v-list-tile>

          <template v-if="order.taxes && order.taxes.length > 0">
            <v-list-tile
              v-for="(tax, index) in order.taxes"
              :key="`tax-${index}`"
            >
              <v-list-tile-content>
                <v-list-tile-sub-title>{{ tax.name }}</v-list-tile-sub-title>
                <v-list-tile-title>
                  {{ $t('Rate:') }} {{ tax.rate }}
                </v-list-tile-title>
              </v-list-tile-content>

              <v-list-tile-action>
                <v-chip
                  small
                  color="transparent"
                >
                  {{ tax.tax | money }}
                </v-chip>
              </v-list-tile-action>
            </v-list-tile>
          </template>
        </v-list-group>

        <v-divider/>

        <v-list-tile>
          <v-list-tile-content>
            <v-list-tile-title class="title">{{ $t('Total') }}</v-list-tile-title>
          </v-list-tile-content>

          <v-list-tile-action>
            <v-chip
              small
              color="primary"
              dark
            >
              {{ order.summary.total_due | money }}
            </v-chip>
          </v-list-tile-action>
        </v-list-tile>
      </v-list>
    </div>
  </VWidget>
</template>

<script>

export default {
  name: 'OrderDraftSummary',

  props: {
    order: {
      type: Object,
      required: true
    }
  }
}
</script>
